// Vue.customElement('widget-vue', {
//     props: [
//       'prop1',
//       'prop2',
//       'prop3'
//     ],
//     data: {
//       message: 'Hello Vue!'
//     },
//     template: '<p>{{ message }}, {{ prop1  }}, {{prop2}}, {{prop3}}</p>'
//   });

const MainOptions = {
  store,
  name: "MainApp",
  delimiters: ["${", "}"],
  compilerOptions: {
    isCustomElement: (tag) => ["slider-component"].includes[tag],
  },
  data() {
    return {
      prueba: "aiodbaoisdbaiosbd",
    };
  },
  computed: {
    numItems() {
      return store.state.cart?.data?.item_count;
    },
    total() {
      return Shopify.formatMoney(store.state.cart?.data?.total_price);
    },
  },
  created() {},
  methods: {
    openNotification() {
      store.dispatch("openNotification").then((response) => {});
    },
  },
};

const MainApp = Vue.createApp(MainOptions);
// MainApp.mount('.main-body')
// MainApp.use(store)

// const p = new Vue({
//     el:".main-body"
// })

const opiniones = document.querySelector(".jdgm-carousel-number-of-reviews");

if (opiniones) {
  const wrapper = document.createElement("a");
  wrapper.setAttribute("href", "https://wunutrition.com/pages/reviews");

  const parent = opiniones.parentNode;
  parent.replaceChild(wrapper, opiniones);
  wrapper.appendChild(opiniones);
}



window.addEventListener("load", () => {
  const items = document.querySelectorAll(".product-card");
  
  items.forEach((item) => {
    const whataStarContainer = item.querySelector('.whata-star-container');
    if(whataStarContainer){
      let reviewText = whataStarContainer.querySelector('div > span:last-child').textContent;
      if (reviewText.includes('(')) {
        let reviewNumberIndex = reviewText.indexOf('(');
        let trimmedText = reviewText.substring(0, reviewNumberIndex - 1);
        whataStarContainer.querySelector('div > span:last-child').textContent = trimmedText;
      }
    }
  });

  document.querySelectorAll('.whata-star-container').forEach(item => {
    item.classList.add('visible');
  });
});
